type WbsStatusKind = 'ON_TRACK' | 'IMPENDING' | 'RISK' | 'DELAY' | 'PLANNED';

const STATUS_LABEL_KO: Record<WbsStatusKind, string> = {
    ON_TRACK: '정시',
    IMPENDING: '임박',
    RISK: '주의',
    DELAY: '지연',
    PLANNED: '예정',
};

export default function StatusBadge({ kind }: { kind: WbsStatusKind }) {
    const cls: Record<WbsStatusKind, string> = {
        ON_TRACK: 'bg-emerald-100 text-emerald-700',
        IMPENDING: 'bg-amber-100 text-amber-700',
        RISK: 'bg-orange-100 text-orange-700',
        DELAY: 'bg-rose-100 text-rose-700',
        PLANNED: 'bg-sky-100 text-sky-700',
    };
    
    return (
        <span className={`inline-flex items-center gap-1 rounded-lg px-2 py-0.5 text-xs ${cls[kind]}`}>
            <i className="w-1.5 h-1.5 rounded-full bg-current" />
            {STATUS_LABEL_KO[kind]}
        </span>
    );
}
